import React from 'react'

const Footer = () => {
    return (
        <footer>
            <p>Made by Hitesh ❤</p>
        </footer>
    )
}

export default Footer
